export const BASE_PATH = process.env.REACT_APP_BASE_PATH;
export const EVENTUS_EVENTS_BASE_PATH = process.env.REACT_APP_EVENTUS_EVENTS_BASE_PATH;
export const EVENTUS_REGISTRATION_BASE_PATH = process.env.REACT_APP_EVENTUS_REGISTRATION_BASE_PATH;

export const withAuthorizationHeader = (headers = {}) => ({
  ...headers,
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const isLogin = () => !!window.localStorage.getItem('token');
